import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Card,
  Stack,
  Typography,
} from "@mui/material";
import Iconify from "../../../../../components/iconify";
import { useLocales } from "../../../../../locales";
import { useMemo } from "react";
const FAQ_KEYS = [
  "what_does_it_do",
  "how_does_it_work",
  "does_it_solve_anything",
];



const FeatureDescriptionAccordion = () => {
  const { translate } = useLocales();

  const faqs = useMemo(
    () =>
      FAQ_KEYS.map((key) => ({
        key,
        heading: translate(`monitoringPage.dataOwl.faq.${key}.heading`),
        detail: translate(`monitoringPage.dataOwl.faq.${key}.detail`),
      })),
    [translate]
  );
  return (
      <>
        {faqs.map((accordion) => (
            <Card sx={{ mt: "6px", mb: "6px" }} key={accordion.key}>
              <Accordion
                  elevation={0}
                  sx={{
                    borderRadius: "16px",
                    padding: "8px 8px",
                    "&:before": { display: "none" },
                    "&.Mui-expanded": { boxShadow: "none", margin: 0 },
                  }}
              >
                <AccordionSummary
                    expandIcon={<Iconify icon="eva:arrow-ios-downward-fill" />}
                >
                  <Typography variant="subtitle2">{accordion.heading}</Typography>
                </AccordionSummary>

                <AccordionDetails>
                  <Typography>{accordion.detail}</Typography>
                </AccordionDetails>
              </Accordion>
            </Card>
        ))}
      </>
  );
};

export default FeatureDescriptionAccordion;
